<template src="./template.html"></template>

<script>
import Vue from 'vue'
import TENKENGYOUMU_BASE from 'src/consts/tenkengyoumu_base'
import TENKENGYOUMU_DETAIL from 'src/consts/tenkengyoumu_detail'
import masterMixin from 'src/mixins/masterMixin'
import notificationMixin from 'src/mixins/notificationMixin'
import tenkenDataRojouApi from 'src/apis/tenken_data_rojou'
import tenkenDataRokaApi from 'src/apis/tenken_data_roka'
import tenkenDataKoukashitaApi from 'src/apis/tenken_data_koukashita'

const apiMap = {
  [TENKENGYOUMU_BASE.ROJOU]: tenkenDataRojouApi,
  [TENKENGYOUMU_BASE.ROKA]: tenkenDataRokaApi,
  [TENKENGYOUMU_BASE.KOUKASHITA]: tenkenDataKoukashitaApi
}

const csvTypeMap = {
  [TENKENGYOUMU_BASE.ROJOU]: {
    [TENKENGYOUMU_DETAIL.DOBOKU]: '路上土木',
    [TENKENGYOUMU_DETAIL.SHISETSU_DENKI]: '路上施設電気',
  },
  [TENKENGYOUMU_BASE.ROKA]: {
    [TENKENGYOUMU_DETAIL.DOBOKU]: '路下土木',
    [TENKENGYOUMU_DETAIL.SHISETSU_DENKI]: '路下施設電気',
  },
  [TENKENGYOUMU_BASE.KOUKASHITA]: {
    [TENKENGYOUMU_DETAIL.KOUKASHITA]: '高架下',
  }
}

export default {
  name: 'search',
  data() {
    return {
      search: {},

      tdds: [],

      tenkenDateRanges: [
        { key: null, val: 'の間' },
        { key: 3, val: '過去3か月' },
        { key: 6, val: '過去6か月' },
        { key: 12, val: '過去1年' },
        { key: 24, val: '過去2年' },
      ],
      comparisonOperators: [
        { key: 'LIKE', val: 'を含む' },
        { key: '=', val: 'である' },
        { key: '!=', val: '以外' },
        { key: 'IS NOT NULL', val: 'データ有り' },
        { key: 'IS NULL', val: 'データ無し' },
      ],

      tenkengyoumuBaseCands: [],
      origTenkengyoumuDetailCands: [],
      tenkenStaffCands: [],
      origTantoujimushoCands: [],
      rosenCands: [],
      rosenMap: {},
      origRosenHoukouCands: [],
      origTenkenKubunCands: [],
      hasonbashoCands: [],
      hasonbashoMap: {},
      hanteiCands: [],
      hanteiMap: {},
      rosenHoukouMap: {},
      tenkenKubunMap: {},

      pagination: {
        currentPage: 1,
        itemsPerPage: 50,
      },

      isRequesting: false,
      isDownloading: false,
    }
  },
  computed: {
    paginatedList() {
      const nextPageIdx = this.pagination.currentPage * this.pagination.itemsPerPage
      const minIdx = nextPageIdx - this.pagination.itemsPerPage
      return this.tdds.filter((e, i) => {
        return i >= minIdx && i < nextPageIdx
      })
    },
    hasList() {
      return this.tdds.length > 0
    },
    isTenkenDateRangeRelative() {
      return this.search.tenkenDateRange !== null
    },
    isHasonbashoNoDisabled() {
      const comp = this.search.hasonbashoNoComp
      return (comp === 'IS NOT NULL') || (comp === 'IS NULL')
    },
    isGairyakuitiDisabled() {
      const comp = this.search.gairyakuitiComp
      return (comp === 'IS NOT NULL') || (comp === 'IS NULL')
    },
    tenkengyoumuDetailCands() {
      const tenkengyoumuBaseId = parseInt(this.search.tenkengyoumuBaseId)
      const isRojou = tenkengyoumuBaseId === TENKENGYOUMU_BASE.ROJOU
      const isRoka = tenkengyoumuBaseId === TENKENGYOUMU_BASE.ROKA
      const isKoukashita = tenkengyoumuBaseId === TENKENGYOUMU_BASE.KOUKASHITA
      return this.origTenkengyoumuDetailCands.filter(e => {
        const detailGyoumuId = parseInt(e.m_tenkengyoumu_detail_id)
        if (isRojou || isRoka) {
          return (detailGyoumuId === TENKENGYOUMU_DETAIL.DOBOKU) ||
            (detailGyoumuId === TENKENGYOUMU_DETAIL.SHISETSU_DENKI)
        } else if (isKoukashita) {
          return detailGyoumuId === TENKENGYOUMU_DETAIL.KOUKASHITA
        }
      })
    },
    tantoujimushoCands() {
      return this.origTantoujimushoCands.filter(e => {
        return (e.detail_gyoumu_id === this.search.detailGyoumuId)
      })
    },
    rosenHoukouCands() {
      return this.origRosenHoukouCands.filter(e => {
        return e.rosen_id === this.search.rosenId
      })
    },
    tenkenKubunCands() {
      return this.origTenkenKubunCands.filter(e => {
        return (e.tenkengyoumu_base_id === this.search.tenkengyoumuBaseId) &&
          (e.tenkengyoumu_detail_id === this.search.detailGyoumuId)
      })
    },
  },
  async mounted() {
    await this.ensureUserAndMasters()
    this.prepareMasters()
    this.resetSearchParams()
    await this.doSearch()
  },
  mixins: [masterMixin, notificationMixin],
  methods: {
    prepareMasters() {
      const master = window.master
      this.tenkengyoumuBaseCands = master.tenkengyoumu_base.vals
      this.origTenkengyoumuDetailCands = master.tenkengyoumu_detail.vals
      this.tenkenStaffCands = master.staff.vals.filter(e => e.is_tenken || e.is_shunin)
      this.origTantoujimushoCands = master.tantoujimusho.vals
      this.rosenCands = master.rosen.vals
      this.rosenMap = master.rosen.vals.reduce((acc, e) => {
        acc[e.m_rosen_id] = e
        return acc
      }, {})
      this.origRosenHoukouCands = master.rosen_houkou.vals
      this.origTenkenKubunCands = master.tenken_kubun.vals
      this.hasonbashoCands = master.hasonbasho.vals
      this.hasonbashoMap = master.hasonbasho.vals.reduce((acc, e) => {
        acc[e.m_hasonbasho_id] = e
        return acc
      }, {})
      this.hanteiCands = master.hantei.vals
      this.hanteiMap = master.hantei.vals.reduce((acc, e) => {
        acc[e.m_hantei_id] = e
        return acc
      }, {})
      this.rosenHoukouMap = master.rosen_houkou.vals.reduce((acc, e) => {
        acc[e.uniq_id] = e
        return acc
      }, {})
      this.tenkenKubunMap = master.tenken_kubun.vals.reduce((acc, e) => {
        acc[e.uniq_id] = e
        return acc
      }, {})
    },
    resetSearchParams() {
      const search = {}
      const now = new Date()
      now.setHours(0, 0, 0, 0)
      search.tenkenDateFrom = now
      search.tenkenDateTo = now
      if (this.tenkengyoumuBaseCands.length > 0) {
        search.tenkengyoumuBaseId = this.tenkengyoumuBaseCands[0].m_tenkengyoumu_base_id
      }
      if (this.origTenkengyoumuDetailCands.length > 0) {
        search.detailGyoumuId = this.origTenkengyoumuDetailCands[0].m_tenkengyoumu_detail_id
      }
      search.tenkenDateRange = this.tenkenDateRanges[0].key
      search.hasonbashoNoComp = this.comparisonOperators[0].key
      search.gairyakuitiComp = this.comparisonOperators[0].key

      this.search = search
    },
    onTenkengyoumuBaseChange() {
      const tenkengyoumuDetail = this.tenkengyoumuDetailCands[0]
      this.search.detailGyoumuId =
        tenkengyoumuDetail ? tenkengyoumuDetail.m_tenkengyoumu_detail_id : null
      this.onTenkenGyoumuDetailChange()
    },
    onTenkenGyoumuDetailChange() {
      this.search.jimushoId = null
      this.search.tenkenkubunId = null
    },
    onRosenChange() {
      this.search.houkouId = null
    },
    adjustTenkenDateRange(prop) {
      if (!this.search[prop]) { return }

      let otherProp
      let sign
      if (prop === 'tenkenDateTo') {
        otherProp = 'tenkenDateFrom'
        sign = -1
      } else {
        otherProp = 'tenkenDateTo'
        sign = 1
      }

      const maxDateRange = this.isTenkenDateRangeRelative ? this.search.tenkenDateRange : 24
      const y = this.search[prop].getFullYear()
      const m = this.search[prop].getMonth() + (maxDateRange * sign)
      let d = this.search[prop].getDate()
      const lastDayOfTheTargetMonth = new Date(y, m + 1, 0)
      if (lastDayOfTheTargetMonth.getDate() < d) {
        d = lastDayOfTheTargetMonth.getDate()
      }
      const dt = new Date(y, m, d)

      const isDateParamOk = !!this.search[otherProp] && this.search.tenkenDateFrom <= this.search.tenkenDateTo
      const isDateRangeOk = Math.abs(this.search[prop] - this.search[otherProp]) <= Math.abs(this.search[prop] - dt)
      if (!this.isTenkenDateRangeRelative && isDateParamOk && isDateRangeOk) { return }

      this.search[otherProp] = dt
    },
    isItemInuse(item) {
      const dtFrom = this.search.tenkenDateFrom
      const dtTo = this.search.tenkenDateTo
      const startDt = new Date(item.start_date)
      const endDt = new Date(new Date(item.end_date).valueOf() + 86400 * 1000)
      return (startDt <= dtFrom) && (dtTo < endDt)
    },
    resetSearchResults() {
      this.tdds = []
      this.pagination.currentPage = 1
      this.routeName = ''
    },
    async doSearch() {
      this.isRequesting = true
      this.resetSearchResults()
      try {
        const search = this.search
        const reqObj = {
          detail_gyoumu_id: search.detailGyoumuId,
          dt_from: search.tenkenDateFrom,
          dt_to: search.tenkenDateTo,
          tenkenin_id: search.tenkeninId,
          jimusho_id: search.jimushoId,
          rosen_id: search.rosenId,
          houkou_id: search.houkouId,
          tenkenkubun_id: search.tenkenkubunId,
          hasonbasho_id: search.hasonbashoId,
          hasonbasho_no: search.hasonbashoNo,
          hasonbasho_no_comp: search.hasonbashoNoComp,
          gairyakuiti: search.gairyakuiti,
          gairyakuiti_comp: search.gairyakuitiComp,
          hantei_id: search.hanteiId,
        }
        const tenkengyoumuBaseId = parseInt(this.search.tenkengyoumuBaseId)
        const { data } = await apiMap[tenkengyoumuBaseId].search(reqObj)
        data.forEach(e => {
          e.tdb = e.tenken_data_base // alias
          e.tdb.rosen = this.rosenMap[e.tdb.rosen_id]
          e.hasonbasho = this.hasonbashoMap[e.hasonbasho_id]
          e.hantei = this.hanteiMap[e.hantei_id]
          e.rosen_houkou = this.rosenHoukouMap[e.uniq_houkou_id]
          e.tenken_kubun = this.tenkenKubunMap[e.uniq_tenkenkubun_id]
        })
        this.tdds = data
        this.isRequesting = false
      } catch (err) {
        console.error('error', err)
        this.isRequesting = false
      }
    },
    downloadBlobAsFile(blob, filename) {
      const url = URL.createObjectURL(blob)
      const a = document.createElement('a')
      a.href = url
      a.download = filename
      a.click()
    },
    async downloadCSV() {
      if (this.isDownloading) { return }

      this.isDownloading = true
      try {
        const tenkengyoumuBaseId = parseInt(this.search.tenkengyoumuBaseId)
        const detailGyoumuId = parseInt(this.search.detailGyoumuId)
        const search = this.search
        const reqObj = {
          detail_gyoumu_id: search.detailGyoumuId,
          dt_from: search.tenkenDateFrom,
          dt_to: search.tenkenDateTo,
          tenkenin_id: search.tenkeninId,
          jimusho_id: search.jimushoId,
          rosen_id: search.rosenId,
          houkou_id: search.houkouId,
          tenkenkubun_id: search.tenkenkubunId,
          hasonbasho_id: search.hasonbashoId,
          hasonbasho_no: search.hasonbashoNo,
          hasonbasho_no_comp: search.hasonbashoNoComp,
          gairyakuiti: search.gairyakuiti,
          gairyakuiti_comp: search.gairyakuitiComp,
          hantei_id: search.hanteiId,
        }
        const { data } = await apiMap[tenkengyoumuBaseId].downloadSearchResultCSV(reqObj)
        const timestamp = Vue.filter('dtFormat')(new Date(), 'yyyymmddHHMMSS')
        const csvType = csvTypeMap[tenkengyoumuBaseId][detailGyoumuId]
        const filename = `検索_${csvType}_${timestamp}.csv`
        this.downloadBlobAsFile(data, filename)
        this.isDownloading = false
      } catch (err) {
        const msg = '検索結果の出力に失敗しました。' +
          '管理者に連絡してください。'
        this.notifyError1(msg, { err })
        this.isDownloading = false
      }
    },
    getDetailPageRouteName(tenkengyoumuBaseId) {
      let ret
      if (this.isTenkengyoumuBaseRojou(tenkengyoumuBaseId)) {
        ret = 'RojouTenkenDetail'
      } else if (this.isTenkengyoumuBaseRoka(tenkengyoumuBaseId)) {
        ret = 'RokaTenkenDetail'
      } else if (this.isTenkengyoumuBaseKoukashita(tenkengyoumuBaseId)) {
        ret = 'KoukashitaTenkenDetail'
      }
      return ret
    },
    isTenkengyoumuBaseRojou(tenkengyoumuBaseId) {
      return parseInt(tenkengyoumuBaseId) === TENKENGYOUMU_BASE.ROJOU
    },
    isTenkengyoumuBaseRoka(tenkengyoumuBaseId) {
      return parseInt(tenkengyoumuBaseId) === TENKENGYOUMU_BASE.ROKA
    },
    isTenkengyoumuBaseKoukashita(tenkengyoumuBaseId) {
      return parseInt(tenkengyoumuBaseId) === TENKENGYOUMU_BASE.KOUKASHITA
    },
  },
}
</script>

<style lang="scss" src="./style.scss" scoped></style>
